/**
 * 抖音APP授权登录
 */
import { useEffect, useState } from 'react'
import { isDouYinEnvironment, getDouyinVersion, compareVersion } from '@/utils/index'

export const douYinLogin = () => {
    const [dysdk, setSdk] = useState(null);

    // 抖音sdk异步初始化函数
    const initDysdk = async (data) => {
        return new Promise((resolve, reject) => {
            dysdk?.error((res) => {
                reject(res)
                console.log('error', JSON.stringify(res))
            });
            dysdk?.ready(() => {
                console.log('dysdk ready')
                resolve(true)
            });

            dysdk?.config({
                params: {
                    client_key: data.thirdAppId,
                    signature: data.sign,
                    timestamp: data.timestamp,
                    nonce_str: data.nonce,
                    url: data.redirectUrl,
                },
            });
        })
    }
    // 唤起抖音授权弹窗
    const showOpenAuth = async (props: any) => {
        const { client_key } = props
        return new Promise((resolve, reject) => {
            dysdk.showOpenAuth({
                params: {
                    client_key,
                    state: '',
                    scopes: {
                        user_info: 0, // 0: 必选；1: 可选，默认不选中； 2: 可选，默认选中
                    },
                    response_type: 'code'
                },
                success: ({ ticket }) => {
                    resolve(ticket)
                },
                error: (res) => {
                    reject(`sdkResError: ${JSON.stringify(res)}`)
                },
            });
        })
    }

    useEffect(() => {
        if (isDouYinEnvironment) {
            const isDouYinApp = compareVersion(`${getDouyinVersion()}`, '10.8');
            isDouYinApp && setSdk((window as any).douyin_open);
            console.log('抖音sdk初始化')
        }
    }, [])

    return { initDysdk, showOpenAuth }
}
